import { c as _c } from "react/compiler-runtime";
import type { ApiNodeDataVerificationCheck } from '@onefootprint/request-types/dashboard';
import useStore from '@/playbook-builder/hooks/use-store';
import type { NodeProps } from '@/playbook-builder/playbook-builder.types';
import BaseNode from '../base-node';
import VerificationCheckForm from './components/verification-check-form/verification-check-form';
const VerificationCheckNode = node => {
  const $ = _c(7);
  const {
    data: t0
  } = useStore();
  const {
    canEdit
  } = t0;
  let t1;
  if ($[0] !== canEdit || $[1] !== node) {
    t1 = {
      form: "verification-check-form",
      render: t2 => {
        const {
          mutation
        } = t2;
        return <VerificationCheckForm node={node} canEdit={canEdit} mutation={mutation} />;
      }
    };
    $[0] = canEdit;
    $[1] = node;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== node.data || $[4] !== node.id || $[5] !== t1) {
    t2 = <BaseNode nodeId={node.id} data={node.data} sidebar={t1} />;
    $[3] = node.data;
    $[4] = node.id;
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return t2;
};
export default VerificationCheckNode;